import { dataFix } from 'global/common/dataFix';
import TreeViewer from 'global/components/viewers/TreeViewer';
import { createRefPath_client } from 'global/firestoreData/appData/appRefPaths';
import _ from 'lodash';
import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { AppUserManagementContext } from '../cnr/contexts/AppUserManagementContext';
import { ParentContext } from '../cnr/contexts/ParentContext';
import { TopicContext } from '../cnr/contexts/TopicContext';
import { getAlphaFromList, getAlphaList } from '../common/convert';
import { uniqueKey } from '../common/keys';
import UiSaveButtons from '../components/buttons/UiSaveButtons';
import AlphabetMenuWithProvider from '../components/menus/AlphabetMenu';
import { gEnums } from '../enums/globalEnums';
import UiSearchFilter from '../pageItem/UiSearchFilter';
import ConfirmationWrapper from '../wrappers/ConfirmationWrapper';
import Wrapper, { wrapperTypes } from '../wrappers/Wrapper';
import WrapperVertCols from '../wrappers/WrapperVertCols';
import AppUserCard from './AppUserCard';
import { useAppUserAuth } from 'global/cnr/contexts/useHelpers/useAppUserAuth';
import { Icon, Image } from 'semantic-ui-react';
import { useFileImage } from 'global/cnr/contexts/useHelpers/useFileImage';
import { _allowUpload, useUpload } from 'global/cnr/contexts/useHelpers/useUpload';
import { MonthCalendars } from 'global/components/calendar/MonthCalendar';
import { _appUserDashboardTypes, SquaresAppUsers } from './SquaresAppUsers';
import { AppDashboardContext } from 'global/components/viewers/AppDashboardOptions';
import { writeBatch } from 'firebase/firestore';
import { logBatch } from 'global/cnr/reducers/reducerHelpers/logging';
// import TeamColors from 'projectSpecific/sports/elements/random/TeamColors';

const _defaultDays = 14
const _alphaTrigger = 60
const _allowProfileUpdates = true

/**
 * 
 * @param {object} props (items, handleClick, showFound, found)
 * @returns A list of appUsers
 */
const AppUsersDashboard = (props) => {

  const { fromDataViewer, dataItems, handleCancel, handleClick, showFound, found, viewOnly, alphaProp } = props ?? {}

  // parentContext
  const parentContext = useContext(ParentContext);
  const { states, handlers, fns } = parentContext ?? {}
  const { app_state, appSettings_state, storage_state, appUsersAuth_state, eventInfo_state, clientInfo_state, paps_state, currentSettings_state } = states ?? {}
  const { appUser_handlers, appUsersAuth_handlers, eventInfo_handlers, appSettings_handlers } = handlers ?? {}
  const { database_fns } = fns
  const { pathViews } = paps_state ?? {}
  const { aps_appUserSettings } = _.get(currentSettings_state, 'gvviSettings', {});
  const { appUserCollection, appUserViewTypeProp } = aps_appUserSettings ?? {}
  const { appUserAuthList, appUserAuthUsageData } = appUsersAuth_state ?? {}
  const { authOn } = appSettings_state ?? {}
  const { appStorageUrlFiles } = storage_state ?? {}
  const _clientProfilesUrls = appStorageUrlFiles?.[gEnums.storageLocationTypes.clientProfiles]
  const { mainDb } = app_state ?? {}

  const appDashboardContext = useContext(AppDashboardContext);
  const { appDashboard_state } = appDashboardContext ?? {}
  const { isSplit } = appDashboard_state ?? {}

  // appUserManagementContext
  const appUserManagementContext = useContext(AppUserManagementContext)
  const { appUserManagement_state, appUserManagement_handlers } = appUserManagementContext ?? {}
  const { appProfileData } = appUserManagement_state ?? {}
  const { adminProfiles, nonProfiledAttendees, nonEventProfiles, attendeeProfiles, clientProfiles, attendeeCounts, profileCounts } = appProfileData ?? {}

  const _counts = pathViews.events ? attendeeCounts : profileCounts
  const _profiles = pathViews.events ? attendeeProfiles : clientProfiles

  // topicContext
  const topicContext = useContext(TopicContext);
  const { topic_state } = topicContext ?? {}

  const [alphaValue, setAlphaValue] = useState(65)
  const [currentProfiles, setCurrentProfiles] = useState(_profiles)
  const [dayCount, setDayCount] = useState(_defaultDays)
  const [itemCount, setItemCount] = useState()
  const [selectedAlphaChar, setSelectedAlphaChar] = useState('a')
  const [selectedFilteredDataList, setSelectedFilteredDataList] = useState()
  const [selectedListType, setSelectedListType] = useState()
  const [showConfirmation, setShowConfirmation] = useState()
  const [sortProp, setSortProp] = useState('lastName')
  const [uniqueProps, setUniqueProps] = useState('lastName')
  const [updatingProfiles, setUpdatingProfiles] = useState()
  const [photoDropped, setPhotoDropped] = useState()

  // use helpers
  const { processing, getAppUserAuths } = useAppUserAuth()
  const { handle_onFileDrop, handleCreate_fileList, fileInfos, handleClear } = useFileImage({ _profiles, forMulti: true })
  const { handleUpload_profiles } = useUpload()

  const [currentImageFiles, setCurrentImageFiles] = useState()
  const [currentImageDroppedFiles, setCurrentImageDroppedFiles] = useState()

  const draggingImageRef = useRef(null);

  const showSearch = useMemo(() => {
    switch (selectedListType) {
      case _appUserDashboardTypes.appUsage:
        return false
      default:
        return true
    }
  }, [selectedListType])

  const { currentData, fullData, showAlpha } = useMemo(() => {
    let _cps = currentProfiles;

    const { recent, found, notFound } = appUserAuthList ?? {}
    if (selectedFilteredDataList) {
      _cps = selectedFilteredDataList
    } else {
      switch (selectedListType) {
        case _appUserDashboardTypes.appUsage:
          break;
        case _appUserDashboardTypes.admins:
          _cps = adminProfiles
          break;
        case _appUserDashboardTypes.total:
          _cps = currentProfiles
          break;
        case _appUserDashboardTypes.recent:
          _cps = recent
          break;
        case _appUserDashboardTypes.found:
          _cps = found
          break;
        case _appUserDashboardTypes.notFound:
          _cps = notFound
          break;
        case _appUserDashboardTypes.nonProfiled:
          _cps = nonProfiledAttendees
          break;
        case _appUserDashboardTypes.photo:
          _cps = _.filter(_cps, item => item.appUserImage);
          break;
        case _appUserDashboardTypes.nonPhoto:
          _cps = _.filter(_cps, item => !item.appUserImage);
          break; f
        case _appUserDashboardTypes.photoSourced:
          _cps = _.filter(_cps, item => item._file);
          break;
        case _appUserDashboardTypes.getFiles:
          _cps = _.filter(_cps, item => item._file);
          break;
        case _appUserDashboardTypes.missingEvent:
          _cps = _.filter(_cps, item => item._hasEvent === false);
          break;
        case _appUserDashboardTypes.missingProfile:
          _cps = _.filter(_cps, item => item._hasProfile === false);
          break;
        case _appUserDashboardTypes.fcm:
          _cps = _.filter(_cps, item => item.fcmTokens);
        default:
          _cps = _cps
      }
    }
    let _currentData = _cps
    const _showAlpha = _.size(_cps) > _alphaTrigger
    if (_.size(_cps) > _alphaTrigger) {
      const { alphaList } = getAlphaList(_cps, selectedAlphaChar, sortProp)
      _currentData = alphaList
    }
    return { currentData: _currentData, fullData: currentProfiles, showAlpha: _showAlpha }
  }, [selectedListType, selectedAlphaChar, photoDropped])

  // modify from _clientProfilesUrls
  useEffect(() => {
    if (!_.isEmpty(_clientProfilesUrls) && _profiles) {
      const _attendeeProfiles = _.mapValues(_profiles, (attendee) => {
        const imageInfo = _clientProfilesUrls[attendee.email];
        return imageInfo?.urls?.thumbnail
          ? { ...attendee, appUserImage: imageInfo }
          : attendee;
      });
      setCurrentProfiles(_attendeeProfiles)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps  
  }, [_clientProfilesUrls, _profiles]);

  // modify from imageFiles (getFiles)
  useEffect(() => {
    if (!_.isEmpty(fileInfos?.imageFiles) || !_.isEmpty(fileInfos?.imageDroppedFiles)) {
      const { imageFiles, imageDroppedFiles } = fileInfos
      const _currentAttendeeProfiles = _.cloneDeep(currentProfiles)
      _.forEach(imageFiles, (imageFile, imageFileKey) => {
        if (_currentAttendeeProfiles?.[imageFileKey]) {
          _currentAttendeeProfiles[imageFileKey]._file = imageFile._file
        }
      })
      setCurrentProfiles(_currentAttendeeProfiles)
      setCurrentImageFiles(imageFiles)
      setCurrentImageDroppedFiles(imageDroppedFiles)
      setSelectedListType(_appUserDashboardTypes.getFiles)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [fileInfos?.imageFiles]);

  useEffect(() => {
    if (!_.isEmpty(_profiles)) {
      setItemCount(_.size(_profiles))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [_profiles]);

  // useEffect(() => {
  //   appUsersAuth_handlers.handleGet_appEventAuths()
  //   // eslint-disable-next-line react-hooks/exhaustive-deps 
  // }, []);

  useEffect(() => {
    appUserManagement_handlers.handleAmmend_auths(dayCount)
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [dayCount]);


  const handleUploadProfileImages = () => {
    const callback = () => {
      console.log('test')
    }
    const uploadPath = `clients/${pathViews.clients}/${'profiles'}`
    const _fileList = _.filter(currentProfiles, item => item._file);
    const fileList = handleCreate_fileList(_fileList)
    handleUpload_profiles({ uploadPath, fileList, useEmail: true, callback })
  }
  // const handle_updateSnapshot = () => {
  //   const cb = (aaa) => {
  //     console.log('aaa', aaa)
  //   }
  //   eventInfo_handlers.handleUpdate_appUserSnapshot(pathViews, appUserAuthList, cb)
  // }

  const createProfiles = async (profiles) => {
    const batch = writeBatch(mainDb);
    // const promises = []
    _.forEach(profiles, (profile, key) => {
      const _profile = dataFix.removeAllEmpties(profile)
      const refPath = createRefPath_client(pathViews, ['profiles', key])
      database_fns.set_doc(refPath, _profile, false, false, batch);
      // promises.push(database_fns.set_doc(refPath, _profile))
    })

    if (_allowProfileUpdates) {
      return await batch.commit()
    }

    logBatch(batch)
    // return Promise.all(promises)
  }

  const handle_removeNonFound = async () => {
    // setUpdatingProfiles(true)
    // await createProfiles(nonProfiledAttendees)
    // setUpdatingProfiles(false)
  }

  const handle_updateNonProfiled = async () => {
    setUpdatingProfiles(true)
    await createProfiles(nonProfiledAttendees)
    setUpdatingProfiles(false)
  }

  const handle_updateNonEvents = async () => {
    setUpdatingProfiles(true)
    await createProfiles(nonEventProfiles)
    setUpdatingProfiles(false)
  }

  const handle_showConfirmation = (opts) => {
    if (!_.isEmpty(opts?.optionType)) {
      setShowConfirmation(opts.optionType)
    } else {
      setShowConfirmation()
    }
  }

  const handleAlphaChange = (av) => {
    const _alphaChar = String.fromCharCode(av)
    setSelectedAlphaChar(_alphaChar)
  }

  const handleDayChange = (e, d) => setDayCount(d.value)
  const handleSelectedListType = (sl) => setSelectedListType(sl)
  const handleGoToEvent = (e) => e.stopPropagation()

  const handleSignInAs = (e, listItem, _itemKey) => {
    e.stopPropagation()
    const actionItem = { dataActionType: 'clone', cloneId: _itemKey, cloneVit: appUserCollection, appUserViewTypeProp: appUserViewTypeProp }
    appUser_handlers.handleClone(actionItem, listItem, paps_state, appUserCollection)
    handleCancel && handleCancel()
  }

  const handleMenuItemClicker = (itemKey) => {
    console.log('itemKey', itemKey)
  }

  const onDrop = (e, appUser) => {
    if (!appUser) { return; }
    e && e.preventDefault();

    const imageFile = draggingImageRef.current;
    const _appUser = JSON.parse(appUser)

    const { email: email_appUser, _itemKey: _itemKey_appUser } = _appUser ?? {}
    const { _dataItem, fileImage, name, src } = imageFile ?? {}
    const { email: email_dropped, _itemKey: _itemKey_dropped } = _dataItem ?? {}

    const _currentAttendeeProfiles = _.cloneDeep(currentProfiles)
    const _currentImageFiles = _.cloneDeep(currentImageFiles)

    if (_currentAttendeeProfiles?.[email_appUser]) {
      _currentAttendeeProfiles[email_appUser]._file = imageFile
      setCurrentProfiles(_currentAttendeeProfiles, selectedAlphaChar)
    }
    if (_currentImageFiles?.[email_appUser]) {
      _currentImageFiles[email_appUser]._file = imageFile
      setCurrentImageFiles(_currentImageFiles)
    }
    setPhotoDropped(!photoDropped)
  };

  const appUserCard = (listItem, lblColor, index) => {
    const { appUserImage } = listItem
    const appUserUrl = appUserImage?.urls?.thumbnail
    const appUserFile = listItem?._file
    const appUserSrc = appUserFile?.src
    return <AppUserCard
      key={uniqueKey('aul', index)}
      appUser={listItem}
      appUserUrl={appUserUrl}
      appUserSrc={appUserSrc}
      index={index}
      lblColor={lblColor}
      handleClick={handleClick}
      handleGoToEvent={handleGoToEvent}
      handleSignInAs={handleSignInAs}
      viewOnly={viewOnly}
      uniqueProps={uniqueProps}
      handleMenuItemClicker={handleMenuItemClicker}
      origin={'aud'}
      onDrop={onDrop}
    />
  }

  const getContent = (item) => {
    const lblColor = showFound ? (found ? 'green' : 'red') : undefined;
    return <div style={{ padding: '.5em' }}>
      {appUserCard(item, lblColor, 0)}
    </div>
  }

  const appUserCards = useMemo(() => {

    let showHasEvent = true
    let showHasProfile = true
    let showLastRefreshTime = false

    if (selectedFilteredDataList) {
      // _data = selectedFilteredDataList
    } else {
      switch (selectedListType) {
        case _appUserDashboardTypes.appUsage:
          return <MonthCalendars appUserAuthUsageData={appUserAuthUsageData} />
        case _appUserDashboardTypes.admins:
        case _appUserDashboardTypes.recent:
        case _appUserDashboardTypes.found:
          showHasEvent = false
          showHasProfile = false
          showLastRefreshTime = true
          break;
        case _appUserDashboardTypes.notFound:
          showHasEvent = false
          showHasProfile = false
          break;
        case _appUserDashboardTypes.total:
        case _appUserDashboardTypes.nonProfiled:
        case _appUserDashboardTypes.nonPhoto:
        case _appUserDashboardTypes.photoSourced:
        case _appUserDashboardTypes.getFiles:
        case _appUserDashboardTypes.missingEvent:
        case _appUserDashboardTypes.missingProfile:
        case _appUserDashboardTypes.fcm:
          break;
        default:
        // nothing
      }
    }

    const _data_tree = _.orderBy(currentData, ['lastName'])

    return <TreeViewer
      forceAlpha={showAlpha}
      data={_data_tree}
      fnPopulate={getContent}
      ignoreCount={true}
      scNames={true}
      subNames={true}
      showHasEvent={showHasEvent}
      showHasProfile={showHasProfile}
      showLastRefreshTime={showLastRefreshTime}
      showItemUrl={true}
      onDrop={onDrop}
    />
  }, [selectedListType, selectedAlphaChar, photoDropped])

  const handleCheck_auths = async () => {
    const cb = (res, totals, usageData) => {
      appUsersAuth_handlers.handleAmmend_appUserAuthList(res, totals, usageData)
    }
    if (pathViews.events && appProfileData.eventProfiles) {
      getAppUserAuths(cb, appProfileData.eventProfiles)
    } else if (!pathViews.events && appProfileData.clientProfiles) {
      getAppUserAuths(cb, appProfileData.clientProfiles)
    }
  }

  const hc_appUsers = (mt) => {
    handleSelectedListType(mt?.key)
  }

  const hc_options = (mt) => {
    switch (mt?.key) {
      case _appUserDashboardTypes.checkAuthorizations:
        handleCheck_auths()
        break;
      case _appUserDashboardTypes.authOn:
        appSettings_handlers.handleToggle_authOn()
        break;
      default:
    }
  }

  const wrapper_appUserCards = () => <Wrapper
    content={appUserCards}
    wrapperType={wrapperTypes.paddedHeader}
  />

  const alphaMenu = () => {

    const grouping = {
      alphaDisplayType: gEnums.alphaDisplayTypes.vertical,
      useVerticalHidden: true,
      verticalOpacity: gEnums.opacityTypes.medium,
      restrictToExisting: true,
    }

    return <AlphabetMenuWithProvider
      origin={'appUserList'}
      dataItems={fullData}
      handleAlphaChange={handleAlphaChange}
      alphaValue={alphaValue}
      restrictToExisting={true}
      sortProp={sortProp}
      grouping={grouping}
    />
  }

  const wrapper_alpha = () => <Wrapper
    alphaMenu={alphaMenu()}
    content={wrapper_appUserCards()}
    wrapperType={wrapperTypes.paddedFooter}
    css={{ container: 'app-user-list' }}
  />

  const wrapper_full = () => <Wrapper
    content={wrapper_appUserCards()}
    wrapperType={wrapperTypes.paddedFooter}
    css={{ container: 'app-user-list' }}
  />

  const handleSearchChange = (searchValue) => {
    if (!_.isEmpty(searchValue) && searchValue !== ' ') {
      const f = _.filter(currentProfiles, function (i) {
        return (searchValue && i.lastName && i.lastName.toLowerCase().startsWith(searchValue.toLowerCase())) ||
          (searchValue && i.firstName && i.firstName.toLowerCase().startsWith(searchValue.toLowerCase()));
      });
      setSelectedFilteredDataList(f)
    } else {
      setSelectedFilteredDataList()
    }
  }

  const searchHeader = () => <div className={'search-page'}><UiSearchFilter handleSearchChange={handleSearchChange} /></div>

  const content_counts = () => <SquaresAppUsers
    adminProfiles={adminProfiles}
    attendeeCounts={_counts}
    authOn={authOn}
    currentDataItems={fullData}
    handle_onFileDrop={handle_onFileDrop}
    hc_appUsers={hc_appUsers}
    hc_options={hc_options}
    itemCount={itemCount}
    nonProfiledAttendees={nonProfiledAttendees}
    selectedListType={selectedListType}
  />

  const wrapper_counts = () => <Wrapper
    header={'App Users'}
    content={content_counts()}
    updating={processing}
    wrapperType={wrapperTypes.padded}
  />

  const footer_appUsers = () => {
    switch (selectedListType) {
      case _appUserDashboardTypes.notFound:
        return <UiSaveButtons
          save={{
            oc: handle_removeNonFound, caption: 'Remove Non Found Profiles', icon: 'save', color: 'green', disabled: _.isEmpty(currentData)
          }}
        />

      case _appUserDashboardTypes.nonProfiled:
        return <UiSaveButtons
          save={{
            oc: handle_updateNonProfiled, caption: 'Update Non Profiled', icon: 'save', color: 'green', disabled: _.isEmpty(nonProfiledAttendees)
          }}
        />

      case _appUserDashboardTypes.missingEvent:
      case _appUserDashboardTypes.missingProfile:
        return <UiSaveButtons
          save={{
            oc: handle_updateNonEvents, caption: 'Update Non Event Profiles', icon: 'save', color: 'green', disabled: _.isEmpty(nonEventProfiles)
          }}
        />

      case _appUserDashboardTypes.photoSourced:
        return <UiSaveButtons
          save={{
            oc: handleUploadProfileImages, caption: 'Update Profile Images', icon: 'save', color: _allowUpload ? 'teal' : 'green', disabled: _.isEmpty(nonEventProfiles)
          }}
        />
    }
  }

  const content_appUsers = () => {
    if (showAlpha) {
      return wrapper_alpha()
    } else {
      return wrapper_full()
    }
  }

  const wrapper_contentAppUsers = () => <Wrapper
    header={`App Users - ${_.startCase(selectedListType)}`}
    search={showSearch && searchHeader()}
    content={content_appUsers()}
    footer={footer_appUsers()}
    wrapperType={wrapperTypes.padded}
    updating={updatingProfiles}
  />

  const onDragStart = (e, imageFile) => {
    draggingImageRef.current = imageFile
  };

  const imageList = () => <div style={{ display: 'flex', gap: '.5em', flexWrap: 'wrap' }}>
    {_.map(fileInfos?.allDroppedFiles, (df) => (
      <div>
        <Image
          src={df.src}
          size='tiny'
          title={df.name}
          onDragStart={(e) => onDragStart(e, df)}
        />
        <div style={{ fontSize: '.7rem', textAlign: 'center', padding: '.2em' }}>{df?._dataItem?.displayName || ''}</div>
      </div>
    ))}
  </div>

  const wrapper_images = () => <Wrapper
    header={<div style={{ display: 'flex', justifyContent: 'space-between' }}><div>Images</div><div><Icon name='delete' color='red' onClick={handleClear} /></div></div>}
    content={imageList()}
    wrapperType={wrapperTypes.padded}
  />

  const hc_selectedIndex = (s) => {
    s === 0 && setSelectedListType()
  }

  const wvc = () => {
    if (!_.isEmpty(currentImageFiles) || !_.isEmpty(currentImageDroppedFiles)) {
      return <WrapperVertCols mvc={'aud-i'} split={!fromDataViewer || isSplit} handleSelectedIndex={hc_selectedIndex} selected_index={selectedListType ? 1 : 0}>
        {wrapper_counts()}
        {wrapper_contentAppUsers()}
        {wrapper_images()}
      </WrapperVertCols>
    } else {
      return <WrapperVertCols mvc={'aud'} split={!fromDataViewer || isSplit} handleSelectedIndex={hc_selectedIndex} selected_index={selectedListType ? 1 : 0}>
        {wrapper_counts()}
        {wrapper_contentAppUsers()}
      </WrapperVertCols>
    }
  }

  if (!handleCancel && showConfirmation) {
    return <ConfirmationWrapper
      showConfirmation={showConfirmation}
      handleShow={handle_showConfirmation}
      // handleCommit={handle_updateSnapshot}
      allowCommit={true}
    />
  } else {
    if (handleCancel) {
      return wvc()
    } else {
      return wrapper_contentAppUsers()
    }
  }

}

export default AppUsersDashboard
